import {
  UPDATE_NEGOCE_FORM,
  GET_DATA_FILTERS,
  GET_DATA_SUBMISSIONS,
  GET_DATA_SYNTHESIS_KPI,
  GET_DATA_SYNTHESIS_SALES_BY_COUNTRY,
  GET_DATA_SYNTHESIS_SALES_BY_WINE,
  GET_DATA_PILOTAGEINTERNE_TOP_NEGOCIANTS,
  GET_DATA_PILOTAGEINTERNE_TOP_CUSTOMERS,
  GET_DATA_RAW,
  GET_DATA_PRESENTION_KPIS
} from '../constants/negoce';
import {
  fetchDataFilters,
  fetchDataSubmissions,
  fetchDataSynthesisKpi,
  fetchDataSynthesisSalesByCountry,
  fetchDataSynthesisSalesByWine,
  fetchDataTopNegociants,
  fetchDataTopCustomers,
  fetchDataRaw,
  fetchDataPresentationKpis
} from '../api/negoce';

export const getDataFilters =
  (campaignId, presentationType) => async (dispatch) => {
    const data = await fetchDataFilters(campaignId, presentationType);
    dispatch({
      type: GET_DATA_FILTERS,
      payload: data
    });
  };

export const updateFormNegoce = (formValues) => async (dispatch) => {
  dispatch({
    type: UPDATE_NEGOCE_FORM,
    payload: formValues
  });
};

export const getDataSubmissions =
  ({ campaignId }) =>
  async (dispatch) => {
    const data = await fetchDataSubmissions({ campaignId });
    dispatch({
      type: GET_DATA_SUBMISSIONS,
      payload: data
    });
  };

export const getDataSynthesisKpi = (optionsValues) => async (dispatch) => {
  const data = await fetchDataSynthesisKpi(optionsValues);
  dispatch({
    type: GET_DATA_SYNTHESIS_KPI,
    payload: data
  });
};

export const getDataSynthesisSalesByCountry =
  (optionsValues) => async (dispatch) => {
    const data = await fetchDataSynthesisSalesByCountry(optionsValues);
    dispatch({
      type: GET_DATA_SYNTHESIS_SALES_BY_COUNTRY,
      payload: data
    });
  };

export const getDataSynthesisSalesByWine =
  (optionsValues) => async (dispatch) => {
    const data = await fetchDataSynthesisSalesByWine(optionsValues);
    dispatch({
      type: GET_DATA_SYNTHESIS_SALES_BY_WINE,
      payload: data
    });
  };

export const getDataTopNegociants = (optionsValues) => async (dispatch) => {
  const data = await fetchDataTopNegociants(optionsValues);
  dispatch({
    type: GET_DATA_PILOTAGEINTERNE_TOP_NEGOCIANTS,
    payload: data
  });
};

export const getDataTopCustomers = (optionsValues) => async (dispatch) => {
  const data = await fetchDataTopCustomers(optionsValues);
  dispatch({
    type: GET_DATA_PILOTAGEINTERNE_TOP_CUSTOMERS,
    payload: data
  });
};

export const getDataPresentationKpis = (optionsValues) => async (dispatch) => {
  const data = await fetchDataPresentationKpis(optionsValues);
  dispatch({
    type: GET_DATA_PRESENTION_KPIS,
    payload: data
  });
};

export const getDataRaw = (optionsValues) => async (dispatch) => {
  const data = await fetchDataRaw(optionsValues);
  dispatch({
    type: GET_DATA_RAW,
    payload: data
  });
};
